import React from "react";
import { useTranslation } from "react-i18next";
import dLogo from "../assets/images/d-logo.svg";

const RotatingCircle = ({ speed = 20 }) => {
  const { t } = useTranslation();
  const text = t("circle.text");
  const size = 275;
  const radius = size / 2 - 15;

  return (
    <div
      className="rotating-circle"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${speed}s`,
      }}
    >
      <svg
        className="circle-text"
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
      >
        <defs>
          <path
            id="circlePath"
            d={`
                M ${size / 2},${size / 2}
                m -${radius}, 0
                a ${radius},${radius} 0 1,1 ${radius * 2},0
                a ${radius},${radius} 0 1,1 -${radius * 2},0
              `}
            fill="none"
          />
        </defs>
        <text
          fill="white"
          fontSize="16"
          fontWeight="300"
          letterSpacing="0.85px"
        >
          <textPath xlinkHref="#circlePath" startOffset="0%">
            {text.repeat(10)}
          </textPath>
        </text>
      </svg>

      <div className="middle-border" />
      <div className="logo-center">
        <img src={dLogo} alt="Logo" />
      </div>
    </div>
  );
};

export default RotatingCircle;
